import { render, staticRenderFns } from "./DetailTransaction.vue?vue&type=template&id=5f364fdd&scoped=true&"
import script from "./DetailTransaction.vue?vue&type=script&lang=ts&"
export * from "./DetailTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./DetailTransaction.vue?vue&type=style&index=0&id=5f364fdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f364fdd",
  null
  
)

export default component.exports